import { Common } from './common';
import * as PatientFeedback from './models/feedback';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async upsert(
    feedback: PatientFeedback.CreateValues,
  ): Promise<PatientFeedback.PatientFeedback> {
    const url = this.common.constructPath(`/patient-previsit/feedback`);
    return this.common.putJSON(url, feedback);
  }
}
